import * as React from 'react';
import { ArticleHeading3, ArticleHeading4, ArticleParagraph2, ArticleParagraph1 } from '@cian/ui-kit';
import * as styles from './SearchResultsEmpty.css';

interface ISearchResultsEmptyProps {
  action: React.ReactNode;
  isDesktop: boolean;
}

export const SearchResultsEmpty: React.FC<ISearchResultsEmptyProps> = props => {
  const { action, isDesktop } = props;

  const Heading = isDesktop ? ArticleHeading3 : /* istanbul ignore next */ ArticleHeading4;
  const Paragraph = isDesktop ? ArticleParagraph1 : /* istanbul ignore next */ ArticleParagraph2;

  return (
    <div className={styles['container']}>
      <div className={styles['image']} />
      <div className={styles['content']}>
        <Heading color="theme-dark">Не нашли ничего подходящего</Heading>
        <Paragraph color="current_color">Попробуйте изменить условия поиска</Paragraph>
      </div>
      <div className={styles['action']}>{action}</div>
    </div>
  );
};
